import useMaterialApi, { Material } from "./MaterialApi";
import usePricingApi, { Pricing } from "./PricingApi";

const hasPricing = (material: Material, pricings: Pricing[]) =>
  pricings.some(pricing => pricing.material.id === material.id);

const applyCustomerPricingToMaterial = (material: Material, pricings: Pricing[]) : Material => {
  const pricing = pricings.find(pricing => pricing.material.id === material.id);
  return pricing ? { ...material, unitPrice: pricing.unitPrice } : material;
};

const useMaterialPricingApi = () => {
  const materialApi = useMaterialApi();
  const pricingApi = usePricingApi();

  const getCustomerMaterialsWithPricingsApplied = (
    customerId: number,
    priceListId: number,
    onlyMaterialsWithPricing: boolean
  ): Promise<Material[]> =>
    new Promise((resolve, reject) => materialApi
      .fetchMaterials()
      .then(materials => pricingApi
        .fetchPricings(customerId, priceListId)
        .then(pricings => resolve(materials
          .filter(material => !onlyMaterialsWithPricing || hasPricing(material, pricings))
          .map(material => applyCustomerPricingToMaterial(material, pricings))))));
  
  return {
    getCustomerMaterialsWithPricingsApplied
  };
};

export default useMaterialPricingApi;